import { useEffect, useState } from "react";
import AdminLayout from "../../commponents/layout/adminLayout";
import PeriodFilter from "../../commponents/dashboard/Periodfilter";
import SummaryCards from "../../commponents/dashboard/Summarycards";
import RevenueTrendChart from "../../commponents/dashboard/Revenuetrendchart";
import StatusDocumentSection from "../../commponents/dashboard/Statusdocumentsection";
import SalesRevenueTable from "../../commponents/dashboard/Salesrevenuetable";
import {
  getDashboardSummary,
  getRevenueTrend,
  getSalesRevenue,
  type DashboardSummary,
  type RevenueTrendItem,
  type SalesRevenueResponse,
} from "../../api/dashboardApi";
import { showError } from "../../utils/ alert";

const CURRENT_YEAR = new Date().getFullYear();

export default function Dashboard() {
  const [startDate, setStartDate] = useState(`${CURRENT_YEAR}-01-01`);
  const [endDate, setEndDate] = useState(`${CURRENT_YEAR}-12-31`);

  const [summary, setSummary] = useState<DashboardSummary | null>(null);
  const [revenueTrend, setRevenueTrend] = useState<RevenueTrendItem[]>([]);
 const [salesRevenue, setSalesRevenue] = useState<SalesRevenueResponse>({
   periods: [],
   rows: [],
 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        setLoading(true);

     

        const [summaryData, trendData, salesData] = await Promise.all([
          getDashboardSummary(startDate, endDate),
          getRevenueTrend(startDate, endDate),
          getSalesRevenue(startDate, endDate),
        ]);

        setSummary(summaryData);
        setRevenueTrend(trendData);
        setSalesRevenue(salesData);
      } catch (error) {
         showError("Failed", "Failed to Load revenue trend.");

      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, [startDate, endDate]);

  const handlePeriodChange = (newStart: string, newEnd: string) => {
    setStartDate(newStart);
    setEndDate(newEnd);
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        <h1 className="text-lg font-semibold text-slate-400">Dashboard</h1>

        <PeriodFilter
          startDate={startDate}
          endDate={endDate}
          onChange={handlePeriodChange}
        />

        <div className="grid gap-6 lg:grid-cols-[1fr_340px]">
          <div className="rounded-2xl bg-white p-6 shadow-sm">
            <div className="mb-1 flex items-center justify-between">
              <h3 className="font-semibold text-[#324A5A]">
                Total Penjualan (Paid Invoice)
              </h3>
              <span className="rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-medium text-slate-500">
                Monthly
              </span>
            </div>
            <p className="mb-4 text-xs text-slate-400">Periode sesuai filter</p>
            {loading ? (
              <p className="py-16 text-center text-sm text-slate-400">
                Loading...
              </p>
            ) : (
              <RevenueTrendChart data={revenueTrend} />
            )}
          </div>

          {loading || !summary ? (
            <div className="rounded-2xl bg-white p-6 text-center text-sm text-slate-400 shadow-sm">
              Loading...
            </div>
          ) : (
            <SummaryCards summary={summary} />
          )}
        </div>

        <StatusDocumentSection startDate={startDate} endDate={endDate} />

        {loading ? (
          <div className="rounded-2xl bg-white p-6 text-center text-sm text-slate-400 shadow-sm">
            Loading...
          </div>
        ) : (
          <SalesRevenueTable data={salesRevenue} />
        )}
      </div>
    </AdminLayout>
  );
}
